import React from 'react'
import { Block, PeopleGrid } from '@components'

const DatoCmsPeopleGrid = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <PeopleGrid {...props} />
    </Block>
  )
}

export default DatoCmsPeopleGrid
